<app-vss-organization-menu [id]="currentOrganizationId"></app-vss-organization-menu>
<div class="container pt-4">
    <div class="row">
        <div class="col">
            <h4 class="border-bottom pb-2 color-primary mb-3">{{'VSS.EVENTS.title' | translate}}
                <a [routerLink]="['/vss','organization', currentOrganizationId, 'events','create']"
                    class="btn btn-sm btn-outline-primary float-end mt-2">
                    {{'VSS.EVENTS.createEvent' | translate}}
                </a>
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.EVENTS.titleHelpText' | translate}}
                </small>
            </h4>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">{{'VSS.EVENTS.TABLE.eventName' | translate}}</th>
                            <th scope="col">{{'VSS.EVENTS.TABLE.eventDate' | translate}}</th>
                            <th scope="col">{{'VSS.EVENTS.TABLE.eventLocation' | translate}}</th>
                            <th scope="col">{{'VSS.EVENTS.TABLE.eventCreatedAt' | translate}}</th>  
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let event of events; let i = index">
                            <th scope="row">{{event['name_' + currentLang]}}</th>
                            <td>{{event.startDate | date:'dd-MM-yyyy'}} - {{event.endDate | date:'dd-MM-yyyy'}}</td>
                            <td>{{event['location_' + currentLang]}}</td>
                            <td>{{event.createdAt | date:'dd-MM-yyyy'}}</td>
                            <td class="text-end">
                                <button type="button" class="btn btn-sm btn-outline-danger" style="margin-right: 5px;"
                                    (click)="onEventDelete(event.id, i)">
                                    <fa-icon [icon]="icons['faTrashAlt']"></fa-icon> {{'GENERAL.delete' |
                                    translate}}
                                </button>
                                <a [routerLink]="['/vss','organization', currentOrganizationId, 'events', event.id, 'update']"
                                    class="btn btn-sm btn-outline-primary">
                                    <fa-icon [icon]="icons['faEdit']"></fa-icon> {{'GENERAL.edit' | translate}}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<app-confirm-modal #confirmModal></app-confirm-modal>